var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-confirm-dialog',{attrs:{"title":"Delete Menu","button-type":"danger","button-text":"Delete","show":_vm.setShow},on:{"update:show":function($event){_vm.setShow=$event},"confirm":_vm.deleteIngredient}},[_c('p',[_vm._v(" Are you sure you want to delete this ingredient, "+_vm._s(_vm.formatText(_vm.ingredient.name))+"? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }